const feedbackLoadingMessages = {
  default: "AGUARDE, POR FAVOR. Estamos processando as informações...",
  sendMail: "AGUARDE, POR FAVOR. Estamos enviando seu e-mail...",
  sendCodeAndMailConfirmation: "AGUARDE, POR FAVOR. Estamos enviando seu código e e-mail...",
  createAccount: "AGUARDE, POR FAVOR. Estamos criando sua conta...",
  loadingProfile: "AGUARDE, POR FAVOR. Estamos carregando seu perfil...",
  loadingUsers: "AGUARDE, POR FAVOR. Estamos carregando os usuários...",
  loadingCity: "AGUARDE, POR FAVOR. Estamos carregando sua cidade...",
  loadingAddress: "AGUARDE, POR FAVOR. Estamos carregando seu endereço...",
  loadingLocation: "AGUARDE, POR FAVOR. Estamos carregando sua localização...",
  loadingBankAccount: "AGUARDE, POR FAVOR. Estamos carregando sua conta bancária...",
  generatingQuizz: "AGUARDE, POR FAVOR. Estamos criando seu questionário...",
  loadingQuizz: "AGUARDE, POR FAVOR. Estamos buscando seu questionário...",
  sendingDocument: "AGUARDE, POR FAVOR. Estamos enviando seu documento...",
  loadingDocument: "AGUARDE, POR FAVOR. Estamos carregando seu documento...",
};
export default feedbackLoadingMessages;
